// auth 2.0
import * as amplitude from "@amplitude/analytics-browser";
import env from "config/env";
import { getApplicationType, isSlidPocketMobileApp } from "utils/utils";
import { isAndroid } from "react-device-detect";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import packageJson from "../../package.json";

export const initAmplitude = (deviceId = null) => {
  const isSlidPocket = isSlidPocketMobileApp();
  const platform = isAndroid ? "Android" : "iOS";

  amplitude.init(env.api_key.amplitude, {
    deviceId,
    defaultTracking: { pageViews: false, sessions: true },
    platform: isSlidPocket ? platform : "Web",
  });

  // ! Because of the limitation of session replay, the error message is always shown. So turn it off for now.
  // const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1 });
  // amplitude.add(sessionReplayTracking);
};

export const setAmplitudeUserId = (userId) => {
  amplitude.setUserId(userId);
};

export const setAmplitudeUserProperties = (properties) => {
  const identifyEvent = new amplitude.Identify();
  Object.entries(properties).forEach(([key, value]) => {
    identifyEvent.set(key, value);
  });
  amplitude.identify(identifyEvent);
};

export const setAmplitudeUserPropertyOnce = (key, value) => {
  const identifyEvent = new amplitude.Identify();
  identifyEvent.setOnce(key, value);
  amplitude.identify(identifyEvent);
};

export const sendAmplitudeData = (eventType, eventProperties, callback) => {
  const applicationType = getApplicationType();

  amplitude.track(eventType, { ...eventProperties, version: packageJson.version, platform: applicationType, domain: "slid web app" }, callback);

  if (window.hj) window.hj("event", eventType);
};
